import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  AssetsApprovalBySchemaNullable,
  AssetsApprovalSchemaNullable,
} from '@iconik-io/iconik-api/src/services/assets';

import type { AssetReviewApprovalsAppState } from './types';

type SetReviewParams = {
  key: string;
  request: AssetsApprovalSchemaNullable | undefined;
};

type SetApprovalsParams = {
  key: string;
  approvals: AssetsApprovalBySchemaNullable[];
};

const initialState: AssetReviewApprovalsAppState = {
  assetReviewRequests: {},
  assetReviewApprovals: {},
};

export const assetReviewApprovalsSlice = createSlice({
  name: 'asset_review_approvals',
  initialState,
  reducers: {
    setAssetReviewRequest: (state, action: PayloadAction<SetReviewParams>) => {
      state.assetReviewRequests[action.payload.key] = action.payload.request;
    },

    setWithMergeAssetReviewRequest: (
      state,
      action: PayloadAction<SetReviewParams>,
    ) => {
      const { key, request } = action.payload;
      state.assetReviewRequests[key] = state.assetReviewRequests[key]
        ? { ...state.assetReviewRequests[key], ...request }
        : request;
    },

    setAssetApprovals: (state, action: PayloadAction<SetApprovalsParams>) => {
      state.assetReviewApprovals[action.payload.key] = action.payload.approvals;
    },
  },
});

export const {
  setAssetReviewRequest,
  setWithMergeAssetReviewRequest,
  setAssetApprovals,
} = assetReviewApprovalsSlice.actions;

export const assetReviewApprovalsReducer = assetReviewApprovalsSlice.reducer;
